import call from "../../service/http";
import { SearchConstants } from "./";

export default {
  namespaced: true,
  state: {
    profile: {},
    profiles: [],
    stats: [],
    loading: false,
    skipToken: null,
    currentCursor: null,
    totalItems: 0,
  },
  mutations: {
    SET_PROFILE: (state, payload) => {
      state.profile = payload;
    },
    SET_PROFILES: (state, payload) => {
      state.profiles = payload;
    },
    SET_STATS: (state, payload) => {
      state.stats = payload;
    },
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },
    SET_SKIP_TOKEN: (state, payload) => {
      state.skipToken = payload;
    },
    SET_CURRENT_CURSOR: (state, payload) => {
      state.currentCursor = payload;
    },
    SET_TOTAL_ITEMS: (state, payload) => {
      state.totalItems = payload;
    }
  },
  getters: {
    loading: (state) => state.loading,
    profile: (state) => state.profile,
    profiles: (state) => state.profiles,
    stats: (state) => state.stats,
    totalItems: (state) => state.totalItems,
    getSkipToken: (state) => state.skipToken
  },
  actions: {
    getStats: (context) => {
      context.commit("SET_LOADING", true, { root: true });
      call("get", SearchConstants.stats)
        .then((res) => {
          context.commit("SET_STATS", res.data.data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },

    search: (context, query) => {
      context.commit("SET_LOADING", true, { root: true });
      call("get", SearchConstants.search(query))
        .then((res) => {
          const { currentCursor, data, total, nextCursor } = res.data.data;
          context.commit("SET_SKIP_TOKEN", nextCursor);
          context.commit("SET_CURRENT_CURSOR", currentCursor);
          context.commit("SET_TOTAL_ITEMS", total);
          context.commit("SET_PROFILES", data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },

    getProfile: (context, profileID) => {
      context.commit("SET_LOADING", true, { root: true });
      call("get", SearchConstants.show(profileID))
        .then((res) => {
          context.commit("SET_PROFILE", res.data.data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },
  },
};
